<template>
  <div id="app">
    <Navbar></Navbar>
    <b-nav id="subnav">
      <b-nav-item><router-link to="/">Processed</router-link></b-nav-item>
      <b-nav-item><router-link to="/live">Live</router-link></b-nav-item>
    </b-nav>
    <router-view></router-view>
    <footer>
      Disclaimer: Some of the instances that populate the catalogue provided via this webpage have been added as part of the feasibility study Solar, Heliospheric and Ionospheric Radio (SHeI-Ra). This activity is funded by the Space Safety Programme of the European Space Agency (ESA) (4000125098/18/D/CT CCN02.). The web-portal of the ESA Space Weather Service Network outlines the main topics touched in the feasibility study via dedicated webpage <a href="https://swe.ssa.esa.int/sheira">https://swe.ssa.esa.int/sheira</a> . Please note that the current page is not part of the ESA SWE Network and it has developed for purely for demonstration and testing purposes.
    </footer>
  </div>
</template>

<script>
import Navbar from "./components/Navbar";

export default {
  name: 'App',
  components: {
    Navbar
  },

}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
#subnav {
  box-shadow: lightcoral 0px 1px 3px;
  margin-bottom: 1rem;

}
#subnav a{
  color: black;
  font-size: 1.2rem;
  justify-content: center;
}

#subnav a .router-link-exact-active{
  color: darkred;
  font-weight: bold;
}

</style>
